import styled from "react-emotion";

export const StyleMenu = styled.div`
  min-width: 160px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgb(0 0 0 / 15%);
  padding: 4px 0;
  background: white;
`;
